// French for the NEXT MOVE zone: the zone note, the disclosure and each rule's verb.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Next move': 'Prochain coup',
  '{n} queued': '{n} en file d’attente',
  'across the live engagements': 'sur les mandats actifs',
  '{n} more, ranked': '{n} de plus, classés par rang',
  'derived check': 'vérification dérivée',
  // the CTA map — a property of the rule
  'New engagement': 'Nouveau mandat',
  'Open Lifecycle': 'Ouvrir le cycle de vie',
  'Open the register': 'Ouvrir le registre',
  'Open the commitment': 'Ouvrir la promesse',
  'Open the review queue': 'Ouvrir la file de vérification',
  'Open the conflicts': 'Ouvrir les conflits',
  'Review the facts': 'Vérifier les faits',
  'Open the questions': 'Ouvrir les questions',
  'Open Contracting': 'Ouvrir le contrat',
  'Open the task': 'Ouvrir la tâche',
  'Open': 'Ouvrir',
}, 'ClientNextMove');
